"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTripSegmentsIntro = void 0;
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const types_1 = require("../../../odSurvey/types");
const getTripSegmentsIntro = (
// FIXME: Type this when there is a few more widgets implemented
options = {}) => ({
    type: 'text',
    text: (t, interview, _path) => {
        var _a;
        const person = odHelpers.getPerson({ interview });
        const journey = odHelpers.getActiveJourney({ interview, person });
        const trip = odHelpers.getActiveTrip({ interview, journey });
        if (!trip || !journey || !person) {
            console.error('trip segments intro: trip, journey or person not found');
            return '';
        }
        const visitedPlaces = odHelpers.getVisitedPlaces({ journey });
        const origin = odHelpers.getOrigin({ trip, visitedPlaces });
        const destination = odHelpers.getDestination({ trip, visitedPlaces });
        if (!origin || !destination) {
            console.error('trip segments intro: origin or destination not found, trip is invalid');
            return '';
        }
        const originName = origin ? odHelpers.getVisitedPlaceName({ visitedPlace: origin, t, interview }) : '';
        const destinationName = destination
            ? odHelpers.getVisitedPlaceName({ visitedPlace: destination, t, interview })
            : '';
        // If origin or destination is a loopActivity, use this activity as context, otherwise, it's the destination
        const activityContext = origin.activity && types_1.loopActivities.includes(origin.activity) ? origin.activity : destination.activity;
        return t(['customSurvey:segments:CurrentTripSegmentsIntro', 'segments:CurrentTripSegmentsIntro'], {
            context: ((_a = options.context) === null || _a === void 0 ? void 0 : _a.call(options, activityContext)) || activityContext,
            count: odHelpers.getCountOrSelfDeclared({ interview, person }),
            originName,
            destinationName
        });
    }
});
exports.getTripSegmentsIntro = getTripSegmentsIntro;
//# sourceMappingURL=widgetTripSegmentsIntro.js.map